import { render, staticRenderFns } from "./ProgressLabels.vue?vue&type=template&id=bfce8876"
import script from "./ProgressLabels.vue?vue&type=script&lang=js"
export * from "./ProgressLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports